import React from "react";

interface AppDynamicContentProps {
  htmlString: string;
  children?: React.ReactNode;
}

export const AppDynamicContent = ({ htmlString, children }: AppDynamicContentProps) => {
  return <div dangerouslySetInnerHTML={{ __html: htmlString }}>{children}</div>;
};
